var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { Alert, Button, LoadingButton, ModalBody, ModalFooter, Typography, TextField, } from '@one-thd/sui-atomic-components';
import { useForm, Controller, FormProvider, } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { OTP_CODE_LENGTH } from '../../../../constants/general';
import { otpValidation } from '../validation';
import { ERR_INCORRECT_OTP, ERR_PRO_UPGRADE, } from '../../../../constants/response-error-messages';
import { setCancelEvent, setVerificationCodeSendAndResendAnalytics, } from '../../../../utils/convert-to-pro-analytics';
export var VerifyCodeModalContent = function (_a) {
    var onCancel = _a.onCancel, onConfirm = _a.onConfirm, verificationCodeReceiver = _a.verificationCodeReceiver, onSendCode = _a.onSendCode, verifiedPhone = _a.verifiedPhone, updateAuthId = _a.updateAuthId;
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useState(false), isIncorrectCode = _c[0], setIsIncorrectCode = _c[1];
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var defaultValues = {
        otpField: '',
    };
    var formMethods = useForm({
        resolver: yupResolver(otpValidation),
        defaultValues: defaultValues,
        mode: 'onChange',
        delayError: 500,
    });
    var control = formMethods.control, _e = formMethods.formState, formErrors = _e.errors, isValid = _e.isValid, handleSubmit = formMethods.handleSubmit, reset = formMethods.reset;
    var resetForm = function () {
        reset();
        setError(null);
        setIsIncorrectCode(false);
    };
    var onConfirmCode = function (values) {
        setError(null);
        setIsIncorrectCode(false);
        var otpField = values.otpField;
        if (!otpField) {
            return;
        }
        setIsLoading(true);
        onConfirm(otpField)
            .catch(function (err) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            var errorCode = ((_e = (_d = (_c = (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.account) === null || _c === void 0 ? void 0 : _c.errors) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.errorCode) || '';
            if (errorCode === 'PASS_ERR_015') {
                setIsIncorrectCode(true);
            }
            else {
                setError(ERR_PRO_UPGRADE);
            }
            if ((_g = (_f = err === null || err === void 0 ? void 0 : err.response) === null || _f === void 0 ? void 0 : _f.headers) === null || _g === void 0 ? void 0 : _g.authid) {
                updateAuthId((_j = (_h = err === null || err === void 0 ? void 0 : err.response) === null || _h === void 0 ? void 0 : _h.headers) === null || _j === void 0 ? void 0 : _j.authid);
            }
        })
            .finally(function () {
            setIsLoading(false);
        });
    };
    var onResendCode = function (method) {
        resetForm();
        setVerificationCodeSendAndResendAnalytics(method === 'sms' ? 'text' : method, true);
        onSendCode(method).catch(function () {
            setError(ERR_PRO_UPGRADE);
        });
    };
    var controllerComponent = function (_a) {
        var _b;
        var field = _a.field;
        var ref = field.ref, onChange = field.onChange, rest = __rest(field, ["ref", "onChange"]);
        var statusMessage = isIncorrectCode
            ? ERR_INCORRECT_OTP.message
            : ((_b = formErrors.otpField) === null || _b === void 0 ? void 0 : _b.message) || '';
        var onChangeWrapped = function (event) {
            setError(null);
            onChange(event);
        };
        return (React.createElement(TextField, { required: true, label: "Enter Verification Code", status: statusMessage ? 'error' : undefined, statusMessage: statusMessage, InputProps: __assign(__assign({ maxLength: OTP_CODE_LENGTH, onChange: onChangeWrapped }, rest), { inputProps: {
                    'data-testid': 'otp-field-inpt',
                } }), autoComplete: "one-time-code" }));
    };
    return (React.createElement(FormProvider, __assign({}, formMethods),
        React.createElement("form", { onSubmit: handleSubmit(onConfirmCode) },
            React.createElement(ModalBody, null,
                React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-6" },
                    React.createElement(React.Fragment, null,
                        verificationCodeReceiver && (React.createElement(Typography, { variant: "body-base" },
                            "We sent a verification code to",
                            ' ',
                            React.createElement(Typography, { weight: "bold", component: "span" }, verificationCodeReceiver))),
                        React.createElement(Controller, { name: "otpField", control: control, render: controllerComponent }),
                        React.createElement(Typography, { variant: "body-base" }, "Didn't receive the code?"),
                        React.createElement("div", { className: "sui-inline-flex sui-gap-3" },
                            React.createElement("button", { type: "button", "data-testid": "resend-email-code-btn", onClick: function () {
                                    onResendCode('email');
                                } },
                                React.createElement(Typography, { color: "primary", decoration: "underline", component: "span" }, "Email me a code")),
                            verifiedPhone && (React.createElement("button", { type: "button", "data-testid": "resend-sms-code-btn", onClick: function () {
                                    onResendCode('sms');
                                } },
                                React.createElement(Typography, { color: "primary", decoration: "underline", component: "span" }, "Text me a code"))),
                            verifiedPhone && (React.createElement("button", { type: "button", "data-testid": "resend-phone-code-btn", onClick: function () {
                                    onResendCode('phone');
                                } },
                                React.createElement(Typography, { color: "primary", decoration: "underline", component: "span" }, "Call me with a code"))))),
                    error && React.createElement(Alert, { status: "error" }, error.message))),
            React.createElement(ModalFooter, null,
                React.createElement("div", { className: "sui-flex sm:sui-flex-row-reverse sui-flex-wrap sm:sui-flex-nowrap sui-gap-6 sui-w-full" },
                    React.createElement(LoadingButton, { fullWidth: true, variant: "primary", type: "submit", disabled: !isValid, loading: isLoading, "data-testid": "submit-code-btn" }, "Submit"),
                    React.createElement(Button, { fullWidth: true, variant: "secondary", "data-testid": "verify-code-cancel-btn", onClick: function () {
                            setCancelEvent("convert to pro xtra overlay: verify your identity: cancel");
                            onCancel();
                        } }, "Cancel"))))));
};
VerifyCodeModalContent.displayName = 'VerifyCodeModalContent';
